@import "../../../../node_modules/@glidejs/glide/dist/css/glide.core.min.css";


.app-carousel {
    position: relative;

    .app-carousel-inner {
        position: relative;
    }

    .glide__slides {
        white-space: normal;
    }

    .control{

        border:none;

        button {
            position: relative;
            width: 100%;
            background: none;
            outline: none;
            box-shadow: none;
            top: 0;
            border: none;


            svg {
                @include svg-format(10px, 20px, rgb(201, 41, 41));
                stroke: rgb(85, 37, 37);
                transition: transform 350ms;
            }

            &:hover {
                svg {
                    transform: scale(1.25);
                }
            }

            &:focus {
                outline: 1px solid #282828;
            }
        }

        &.hidden{
            visibility: hidden;
        }
    }

    .glide__slides {
        white-space: normal;
    }

    .control{

        border:none;

        button {
            position: relative;
            width: 100%;
            background: none;
            outline: none;
            box-shadow: none;
            top: 0;
            border: none;


            svg {
                @include svg-format(10px, 20px, rgb(201, 41, 41));
                stroke: rgb(85, 37, 37);
                transition: transform 350ms;
            }

            &:hover {
                svg {
                    transform: scale(1.25);
                }
            }
        }

        &.hidden{
            visibility: hidden;
        }
    }

    .glide__bullets{

        height: 16px;
        display: flex;
        align-items: center;
        justify-content: center;

        .glide__bullet{
            border-radius: 100%;
            padding:0;
            height:8px;
            width:8px;
            border:none;
            background-color: #495972;
            margin: 0 9.5px;
    
        }
    
        .glide__bullet--active
        {
            height:14px;
            width:14px;
        }
    }

    .controls {

        button {
            position: absolute;
            top: 0;
            left: 0;
            width: 80px;
            height: 100%;
            background: none;
                background-image:    
                    linear-gradient(
                    to right, 
                    rgba(0,0,0,.5), transparent
                    );
                // reset default btn style
                border: none;
                outline: none;
                box-shadow: none;
    
                svg {
                    @include svg-format(30px, 40px, #fff);
                    stroke: #FFF;
                    transition: transform 350ms;
                }
    
                &:hover {
                    svg {
                        @include media-breakpoint-up(xl) {
                            transform: scale(1.25);
                        }
                        @include media-breakpoint-down(xl) {
                            transform: translate(-50%, -50%) scale(1.25);
                        }
                    }
                }

                &:focus {
                    outline: 1px solid #282828;
                }
        }
    
        [data-glide-dir=">"] {
            left: auto;
            right: 0;

            background-image:
                linear-gradient(
                to right, 
                transparent,  rgba(0,0,0,.5)
            );
        }

    }   

    @include media-breakpoint-down(md) {
        .controls {
            button {
                width: 40px;

                svg {
                    min-width: 15px;
                    max-width: 15px;
                    max-height: 25px;
                }
            }
        }
    }
}
